import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AnnotationsService } from '../../../services/annotations.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MainHeaderComponent } from '../../shared/main-header/main-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject, filter, Observable, switchMap, take } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CvatTasksService } from '../../../services/cvat-tasks.service';

@Component({
  selector: 'app-cvat-basic-tasks',
  standalone: true,
  imports: [MainHeaderComponent, MatFormFieldModule, CommonModule, ReactiveFormsModule, MatIconModule, MatInputModule, MatButtonModule],
  templateUrl: './cvat-basic-tasks.component.html',
  styleUrl: './cvat-basic-tasks.component.scss'
})
export class CvatBasicTasksComponent {
  csvFile: File[] = [];
  selected_files: File[] = [];
  folder_name: string = "";
  imageCount: number = 0;
  fileDisplayText: string = '';
  titleheader: string = '';
  project_id!: number;
  creating?: boolean = true
  for_save: boolean = false
  task_id?: number;
  jobs$!: Observable<any[]>;

  constructor(private fb: FormBuilder,private cvatTaskService: CvatTasksService ,private annotationService: AnnotationsService, private _snackBar: MatSnackBar, private route: ActivatedRoute) { }
  ngOnInit(){
   this.project_id = +this.route.snapshot.paramMap.get('project_id')!;
   this.task_id = +this.route.snapshot.paramMap.get('task_id')!;
   console.log('ID DEL PROYECTO:', this.project_id);
   console.log('Task ID:', this.task_id);
   if(this.task_id){
    this.creating = false; 
    this.titleheader = 'Detalle de la tarea';
    this.refreshTasks(this.task_id);
      this.jobs$ = this.cvatTaskService.getJobsByTaskId(this.task_id);
   } else {
    this.titleheader = 'Creando tarea';
   }
  }
  formConfig = [
      {
        controlName: "name",
        label: "Nombre de la tarea",
        type: "text",
        width: "80%",
        margin: "",
      },
      {
        controlName: "segment_size",
        label: "Segmentación",
        type: "number",
        width: "15%",
        margin: "0 0 0 1rem",
      
      },
    ];
  
    AnnotationsForm: FormGroup = this.fb.group({
      name: ["", Validators.required],
      segment_size: [""],
    });

  saveTasks(){
    if(this.selected_files.length > 0 && !this.imageProcessingDone.value){
      this.uploadAndSend();
    }
    if(this.csvFile.length > 0 && !this.imageProcessingDone.value){
      this.processCSV();
    }
    const rawData = this.AnnotationsForm.value;
    const taskData = {
      name: rawData.name,
      segment_size: Number(rawData.segment_size),
      project_id: this.project_id,
    };
    this.getImagesProcessed$().pipe(
          filter(ready => ready === true),
          take(1),
          switchMap(() => this.annotationService.createTask(taskData))
        ).subscribe({
          next: (res) => {
            this._snackBar.open('Tarea creada correctamente', 'ok');
            console.log("Tarea creada correctamente", res);
          },
          error: (e) => {
            this._snackBar.open('Ocurrió un error al crear la tarea', 'ok');
            console.error("Error al crear la tarea", e);
          }  
        })

        this.for_save = false;
  }
  
  refreshTasks(task_id: number) {
    this.cvatTaskService.getTasksDetails(task_id).subscribe({
    next: (task) => {
      this.AnnotationsForm.patchValue({
        name: task.name,
        segment_size: task.segment_size,
      });
    },
    error: (err) => {
      console.error("Error al cargar detalles de tarea:", err);
    }
  });
  }

  private imageProcessingDone = new BehaviorSubject<boolean>(false);
  
  setImagesProcessed(done: boolean) {
    this.imageProcessingDone.next(done);
  }
  
  getImagesProcessed$(): Observable<boolean> {
    return this.imageProcessingDone.asObservable();
  }
  
  eventCsv(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const files = Array.from(input.files);
    this.csvFile = files
    this.selected_files = []
    this.fileDisplayText = files.map(f => f.name).join(', ');
  }


  // metodo para  validar que tenga las columnas requeridas, enviar csv al backend
  // para procesar las urls y crear tareas con el SDK de cvat
  processCSV() {
    console.log('Procesando csv');

    if (!this.csvFile) {
      console.warn("No se ha seleccionado ningún archivo CSV.");
      return;
    }

    const column = 'urls';
    let validFilesCount = 0;
    const totalFiles = this.csvFile.length;

    for (const file of this.csvFile) {
      const reader = new FileReader();

      reader.onload = () => {
        const text = reader.result as string;
        const lines = text.split('\n');
        const imageCount = lines.length - 1;
        this.imageCount = imageCount;

        const headers = lines[0].split(',').map(h => h.trim().replace(/['"']+/g, ''));

        console.log(`Headers del archivo ${file.name}:`, headers);

        if (!headers.includes(column)) {
          alert(`El archivo "${file.name}" no contiene la columna requerida: "${column}"`);
          return;
        }

        validFilesCount++;

        if (validFilesCount === totalFiles) {
          const formData = new FormData();
          for (const f of this.csvFile) {
            formData.append('file', f);
          }

          console.log("csv en formdata:", formData);

          this.annotationService.sendCsv(formData).subscribe({
            next: () => {
              this.setImagesProcessed(true);
        
              console.log("CSV enviado a Python correctamente");
            },
            error: (e) => {
              this._snackBar.open('Ocurrió un error al cargar las imagenes', 'ok')
              console.error("Error al enviar el archivo CSV a Python", e)
              this.setImagesProcessed(false);
            }
          });
        }
      };

      reader.onerror = (error) => {
        console.error(`Error al leer el archivo ${file.name}:`, error);
      };

      reader.readAsText(file);
    }
  }



  eventImage(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const files = Array.from(input.files);
    this.selected_files = files
    this.csvFile = [];

    this.fileDisplayText = `${files.length} imagen${files.length > 1 ? 'es' : ''} 
      cargada${files.length > 1 ? 's' : ''}`;

    this.folder_name = `carpeta${Date.now()}`;

    console.log("Imágenes detectadas. Carpeta:", this.folder_name);
  }


  // metodo para enviar imagenes por lotes en una misma carpeta al cloud storage
  // para enviar las  urls a la api de python, descargar y crear tarea con el SDK de cvat
  uploadAndSend() {
    if (!this.selected_files.length) return;
    const batchSize = 20;
    const batches = [];
    const bucketName = 'cvat_pre_training'
    this.imageCount = this.selected_files.length;

    for (let i = 0; i < this.selected_files.length; i += batchSize) {
      batches.push(this.selected_files.slice(i, i + batchSize));
    }
    let completedUploads = 0;

    batches.forEach((batch) => {
      const formData = new FormData();
      formData.append("folder", this.folder_name);
      formData.append('bucketName', bucketName)

      for (const file of batch) {
        const path = (file as any).webkitRelativePath || file.name;
        formData.append("files", file, path);
      }
      this.annotationService.uploadImages(formData).subscribe({
        next: () => {
          completedUploads++;

          if (completedUploads === batches.length) {
            this.annotationService.sendUrlsBucket(this.folder_name, bucketName).subscribe({
              next: () => {
                this.setImagesProcessed(true);
                console.log("URLs enviadas a Python correctamente")
                
              },
              error: (e) => { 
                this._snackBar.open('Ocurrió un error al cargar las imagenes', 'ok')
                console.error("Error al enviar urls a python", e)
                
              }
            });
          }
        },
        error: (err) => {
          this.setImagesProcessed(false);
          console.error("Error al subir la carpeta", err)
        }
      });
    });
  }


}
